import OutcomeType from "@/constants/OutcomeType";

class OutcomePermissions {
	constructor( { outcome, userProfile, timezone, meetingPermissions, } ) {
		this.outcome = outcome;
		this.userProfile = userProfile;
		this.timezone = timezone;
		if ( meetingPermissions.resolve ) {
			meetingPermissions = meetingPermissions.resolve();
		}
		this.meetingPermissions = meetingPermissions;
	}

	canOutcomeBeCompleted() {
		return this.outcome.type === OutcomeType.COMMITMENT;
	}

	//
	// user
	//
	canUserCompleteOutcome() {
		const { userProfile, assignments = [], } = this;
		const isAssignedToCommitment = !!assignments.find( assignment => {
			return assignment.assigner_id === userProfile.personId ||
				assignment.assigned_id === userProfile.personId;
		} );

		const hasExplicitCompletePerms = ( this.meetingPermissions && !!this.meetingPermissions.canCompleteCommitments );
		return hasExplicitCompletePerms || isAssignedToCommitment;
	}

	canUserAssignOutcome() {
		const isUserOrganizer = this.meetingPermissions.isUserOrganizer;
		const isUserInvitee = this.meetingPermissions.isUserInvitee;
		return isUserOrganizer || isUserInvitee;
	}

	resolve() {
		return {
			outcomeId: this.outcome.id,
			userId: this.userProfile.personId,
			canUserCompleteOutcome: this.canUserCompleteOutcome(),
			canUserAssignOutcome: this.canUserAssignOutcome(),
		};
	}
}

export default OutcomePermissions;



// WEBPACK FOOTER //
// ./src/permissions/OutcomePermissions.js